module.exports = __webpack_public_path__ + "static/media/teleprospection2.78d49898.jpg";